module.exports = "/_next/static/images/b7f8114e1340c9abd733884eecfe6e1f-hero-belinda-desktop.jpg.webp";